import {
  CREATE_NOTIFICATION,
  DISMISS_NOTIFICATION
} from '../constants/notification';

export const notifyUser = (notification, dismissAfter = 5000) => dispatch => {
  dispatch({
    type: CREATE_NOTIFICATION,
    notification
  });
  setTimeout(() => {
    dispatch({
      type: DISMISS_NOTIFICATION
    })
  }, dismissAfter)
}

export const dismissNotification = () => dispatch => {
  dispatch({
    type: DISMISS_NOTIFICATION
  })
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification.js